// AdminUsuariosPage — CRUD de operadores
import { useEffect, useState } from 'react';
import { admin } from '../../lib/api.js';

const PAPEIS = [
  { v: 'admin',    label: 'Admin (acesso total)',         badge: '#fee2e2', cor: '#991b1b' },
  { v: 'operador', label: 'Operador (uso operacional)',   badge: '#dbeafe', cor: '#1e3a8a' },
  { v: 'consulta', label: 'Consulta (somente leitura)',   badge: '#f3f4f6', cor: '#4b5563' },
];
const papelInfo = (p) => PAPEIS.find(x => x.v === p) || PAPEIS[1];

export default function AdminUsuariosPage() {
  const [ops, setOps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState(null);
  const [modalNovo, setModalNovo] = useState(false);
  const [novaSenhaModal, setNovaSenhaModal] = useState(null);

  async function recarregar() {
    setLoading(true);
    try {
      const r = await admin.listarOperadores();
      setOps(r.data || []);
      setErro(null);
    } catch (e) { setErro(e.uiMessage || 'Erro'); }
    setLoading(false);
  }

  useEffect(() => { recarregar(); }, []);

  async function criar(body) {
    try {
      const r = await admin.criarOperador(body);
      setModalNovo(false);
      if (r.senha_temporaria) {
        setNovaSenhaModal({ operador: r.data, senha: r.senha_temporaria });
      }
      await recarregar();
    } catch (e) { alert(e.uiMessage || 'Erro ao criar'); }
  }

  async function resetar(id, nome) {
    if (!confirm(`Resetar senha de ${nome}? Será gerada uma nova senha temporária.`)) return;
    try {
      const r = await admin.resetarSenha(id);
      setNovaSenhaModal({ operador: { id, nome_completo: nome }, senha: r.data.senha_temporaria });
    } catch (e) { alert(e.uiMessage); }
  }

  async function alterarPapel(op, novoPapel) {
    if (op.papel === novoPapel) return;
    try {
      await admin.atualizarOperador(op.id, { papel: novoPapel });
      await recarregar();
    } catch (e) { alert(e.uiMessage); }
  }

  async function toggleAtivo(op) {
    const action = op.ativo ? 'desativar' : 'reativar';
    if (!confirm(`Tem certeza que deseja ${action} ${op.nome_completo}?`)) return;
    try {
      if (op.ativo) await admin.desativarOperador(op.id);
      else          await admin.atualizarOperador(op.id, { ativo: true });
      await recarregar();
    } catch (e) { alert(e.uiMessage); }
  }

  return (
    <div className="stack">
      <div className="row between" style={{ marginBottom: 16 }}>
        <h1 style={{ margin: 0 }}>Usuários</h1>
        <button className="btn primary" onClick={() => setModalNovo(true)}>+ Novo usuário</button>
      </div>

      {erro && <div className="card error">{erro}</div>}
      {loading && <div className="muted">Carregando...</div>}

      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        <table className="admin-table">
          <thead>
            <tr>
              <th>Nome</th>
              <th>Username</th>
              <th>Email</th>
              <th>Papel</th>
              <th>Último login</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {ops.map(op => {
              const info = papelInfo(op.papel);
              return (
                <tr key={op.id} style={{ opacity: op.ativo ? 1 : 0.45 }}>
                  <td><strong>{op.nome_completo}</strong></td>
                  <td><code>{op.username}</code></td>
                  <td style={{ fontSize: 12, color: '#6b7280' }}>{op.email || '—'}</td>
                  <td>
                    <select
                      value={op.papel}
                      onChange={e => alterarPapel(op, e.target.value)}
                      style={{
                        padding: '3px 8px', borderRadius: 4,
                        background: info.badge, color: info.cor,
                        border: 'none', fontSize: 11, fontWeight: 600,
                      }}
                    >
                      {PAPEIS.map(p => <option key={p.v} value={p.v}>{p.label}</option>)}
                    </select>
                  </td>
                  <td style={{ fontSize: 11, color: '#6b7280' }}>
                    {op.ultimo_login_at
                      ? new Date(op.ultimo_login_at).toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' })
                      : 'nunca'}
                    <br/>
                    <span style={{ fontSize: 10 }}>{op.total_logins} logins</span>
                  </td>
                  <td>
                    <span className={`status-pill ${op.ativo ? 'ativo' : 'inativo'}`}>
                      {op.ativo ? 'ativo' : 'inativo'}
                    </span>
                  </td>
                  <td>
                    <div style={{ display: 'flex', gap: 4 }}>
                      <button className="btn small secondary" onClick={() => resetar(op.id, op.nome_completo)}>
                        🔑 Resetar
                      </button>
                      <button className="btn small secondary" onClick={() => toggleAtivo(op)}>
                        {op.ativo ? '⏸ Desativar' : '▶ Reativar'}
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {modalNovo && <ModalNovoUsuario onSalvar={criar} onCancelar={() => setModalNovo(false)} />}
      {novaSenhaModal && (
        <ModalSenhaGerada
          operador={novaSenhaModal.operador}
          senha={novaSenhaModal.senha}
          onFechar={() => setNovaSenhaModal(null)}
        />
      )}
    </div>
  );
}

function ModalNovoUsuario({ onSalvar, onCancelar }) {
  const [form, setForm] = useState({
    username: '', nome_completo: '', email: '', telefone: '', papel: 'operador',
  });
  return (
    <div className="modal-bg" onClick={onCancelar}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <h3 style={{ marginTop: 0 }}>Novo usuário</h3>
        <p style={{ fontSize: 12, color: '#6b7280', marginTop: 0 }}>
          Senha temporária será gerada automaticamente.
        </p>
        <label>Username (login)
          <input value={form.username} onChange={e => setForm({...form, username: e.target.value.toLowerCase()})} placeholder="ex: joao.silva" />
        </label>
        <label>Nome completo
          <input value={form.nome_completo} onChange={e => setForm({...form, nome_completo: e.target.value})} />
        </label>
        <label>Email (opcional)
          <input type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} />
        </label>
        <label>Telefone (opcional)
          <input value={form.telefone} onChange={e => setForm({...form, telefone: e.target.value})} placeholder="(48) 99999-0000" />
        </label>
        <label>Papel
          <select value={form.papel} onChange={e => setForm({...form, papel: e.target.value})}>
            {PAPEIS.map(p => <option key={p.v} value={p.v}>{p.label}</option>)}
          </select>
        </label>
        <div className="row" style={{ marginTop: 16, gap: 8, justifyContent: 'flex-end' }}>
          <button className="btn secondary" onClick={onCancelar}>Cancelar</button>
          <button className="btn primary"
            disabled={!form.username || !form.nome_completo}
            onClick={() => onSalvar(form)}>Criar e gerar senha</button>
        </div>
      </div>
    </div>
  );
}

function ModalSenhaGerada({ operador, senha, onFechar }) {
  function copiar() {
    navigator.clipboard.writeText(senha);
    alert('Senha copiada!');
  }
  return (
    <div className="modal-bg" onClick={onFechar}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <h3 style={{ marginTop: 0 }}>🔑 Senha temporária gerada</h3>
        <p style={{ fontSize: 13 }}>Usuário: <strong>{operador.nome_completo}</strong></p>
        <div style={{
          background: '#fef3c7', border: '1px solid #fbbf24', padding: 12,
          borderRadius: 6, fontFamily: 'monospace', fontSize: 18, textAlign: 'center',
          letterSpacing: 1, marginBottom: 12,
        }}>
          {senha}
        </div>
        <p style={{ fontSize: 12, color: '#92400e' }}>
          ⚠ <strong>Esta senha não será exibida novamente.</strong> Copie agora e repasse ao usuário.
        </p>
        <div className="row" style={{ gap: 8, justifyContent: 'flex-end' }}>
          <button className="btn secondary" onClick={copiar}>📋 Copiar</button>
          <button className="btn primary" onClick={onFechar}>Fechar</button>
        </div>
      </div>
    </div>
  );
}
